import React from "react";
import type { CabinetEdgeType, CabinetNodeKind } from "../../types/cabinet";
import {
	EDGE_TYPE_STYLES,
	NODE_KIND_STYLES,
	edgeDashArray,
} from "./cabinetTheme";

const KINDS = Object.keys(NODE_KIND_STYLES) as CabinetNodeKind[];
const EDGE_TYPES = Object.keys(EDGE_TYPE_STYLES) as CabinetEdgeType[];

/**
 * Legend for the cabinet graph — node kinds (colour + relative size) and edge
 * types (stroke pattern). Rendered in Tailwind rather than through the ECharts
 * legend component because ECharts cannot legend edge line styles.
 */
const CabinetLegend: React.FC = () => (
	<div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-gray-200 px-4 py-2">
		<div className="flex flex-wrap items-center gap-x-4 gap-y-2">
			<span className="text-xs font-medium text-text-muted">Nodes</span>
			{KINDS.map((kind) => {
				const style = NODE_KIND_STYLES[kind];
				return (
					<span key={kind} className="flex items-center gap-1.5">
						<span
							aria-hidden="true"
							className={`inline-block rounded-full ${
								kind === "deal"
									? "h-3 w-3 bg-primary"
									: kind === "document"
										? "h-2.5 w-2.5 bg-primary-500"
										: "h-2 w-2 bg-amber-700"
							}`}
						/>
						<span className="text-xs text-text-base">{style.label}</span>
						<span className="text-xs text-text-muted">
							— {style.description}
						</span>
					</span>
				);
			})}
		</div>

		<div className="flex flex-wrap items-center gap-x-4 gap-y-2">
			<span className="text-xs font-medium text-text-muted">Edges</span>
			{EDGE_TYPES.map((edgeType) => {
				const style = EDGE_TYPE_STYLES[edgeType];
				return (
					<span key={edgeType} className="flex items-center gap-1.5">
						<svg
							aria-hidden="true"
							className="inline-block"
							width="24"
							height="4"
							viewBox="0 0 24 4"
						>
							<line
								x1="0"
								y1="2"
								x2="24"
								y2="2"
								stroke={style.color}
								strokeWidth="2"
								strokeDasharray={edgeDashArray(style)}
							/>
						</svg>
						<span className="font-mono text-xs text-text-base">
							{style.label}
						</span>
						<span className="text-xs text-text-muted">
							— {style.description}
						</span>
					</span>
				);
			})}
		</div>
	</div>
);

export default CabinetLegend;
